module.exports = "<div class=modal-content> <div class=modal-header> <h5 class=modal-title translate>Attention!</h5> </div> <div class=modal-body> <p translate>You did not update your cart with the quantities you last modified.</p> </div> <div class=modal-footer> <button class=\"btn btn-primary\" test-context=option-discard ng-click=vm.cancel($event) translate>Update cart</button> <button class=\"btn btn-primary-outline\" test-context=option-cancel ng-click=vm.discard($event) type=button translate>Continue without updating cart</button> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/common/dialogs/unsaved-changes-dialog.html
// module id = 582
// module chunks = 0